import * as z from "zod";

export const LoginSchema = z.object({
  email: z
    .string()
    .trim()
    .email({
      message: "Email is required",
    })
    .transform((email) => email.toLowerCase()),
  password: z.string().trim().min(1, {
    message: "Password is required",
  }),
  code: z.optional(z.string()),
  isHashed: z.optional(z.string()),
});

export const RegisterSchema = z.object({
  email: z.string().trim().toLowerCase().email({
    message:
      "The email address is invalid. Make sure it's in the following format: example@email.com.",
  }),
  password: z.string().trim().min(8, {
    message: "Minimum 8 characters required",
  }),
});

export const NewPasswordSchema = z.object({
  password: z.string().trim().min(8, {
    message: "Minimum of 8 characters required",
  }),
});

export const ResetSchema = z.object({
  email: z.string().email("Invalid email address"),
});
